import { Inject, InjectionToken, Optional, Pipe, PipeTransform } from '@angular/core';

export const COUNTRY_CODE_TOKEN = new InjectionToken<string>('COUNTRY_CODE');
export const IS_EXPERANZA_FLOW_FN = new InjectionToken<() => boolean>('IS_EXPERANZA_FLOW_FN');

interface TermReplacement {
  from: RegExp;
  to: string;
}

const COUNTRY_REPLACEMENTS: Record<string, TermReplacement[]> = {
  PE: [
    { from: /\bResumen del cr[eé]dito\b/gi, to: 'Resumen de la compra' },
    { from: /\bConsolidación del cr[eé]dito\b/gi, to: 'Consolidación de la compra' },
    { from: /\bN° del cr[eé]dito\b/gi, to: 'N° de la compra' },
    { from: /\bdesembolso del cr[eé]dito\b/gi, to: 'desembolso de la compra' },
    { from: /\botorgamiento del cr[eé]dito\b/gi, to: 'otorgamiento de la compra' },
    { from: /\bnuevo cr[eé]dito\b/gi, to: 'nueva compra' },
    { from: /\bel cr[eé]dito\b/gi, to: 'la compra' },
    { from: /\bEl cr[eé]dito\b/g, to: 'La compra' },
    { from: /\bdel cr[eé]dito\b/gi, to: 'de la compra' },
    { from: /\bun cr[eé]dito\b/gi, to: 'una compra' },
    { from: /\bUn cr[eé]dito\b/g, to: 'Una compra' },
    { from: /\btu cr[eé]dito\b/gi, to: 'tu compra' },
    { from: /\bCr[eé]dito nuevo\b/g, to: 'Compra nueva' },
    { from: /\bcr[eé]dito nuevo\b/gi, to: 'compra nueva' },
    { from: /\bCr[eé]dito anterior\b/g, to: 'Compra anterior' },
    { from: /\bcr[eé]dito anterior\b/gi, to: 'compra anterior' },
    { from: /\bcr[eé]dito activo\b/gi, to: 'compra activa' },
    { from: /\bcr[eé]dito web\b/gi, to: 'compra web' },
    { from: /\bcr[eé]dito de cash\b/gi, to: 'compra de cash' },
    { from: /\bsolicitud de cr[eé]dito\b/gi, to: 'solicitud de compra' },
    { from: /\breportes de cr[eé]dito\b/gi, to: 'reportes de compra' },
    { from: /\bReportes de Cr[eé]dito\b/g, to: 'Reportes de Compra' },
    { from: /\bcontrato de cr[eé]dito\b/gi, to: 'contrato de compra' },
    { from: /\bmonto de cr[eé]dito\b/gi, to: 'monto de compra' },
    { from: /\bde cr[eé]dito\b/gi, to: 'de compra' },
    { from: /\bcr[eé]dito\b/gi, to: 'compra' },
  ],
};

@Pipe({
  name: 'termReplace',
})
export class TermReplacePipe implements PipeTransform {
  private replacements: TermReplacement[] | null = null;
  private isExperanzaFlowFn: (() => boolean) | null = null;

  constructor(
    @Optional() @Inject(COUNTRY_CODE_TOKEN) countryCode: string | null,
    @Optional() @Inject(IS_EXPERANZA_FLOW_FN) isExperanzaFlowFn: (() => boolean) | null
  ) {
    this.replacements = countryCode ? (COUNTRY_REPLACEMENTS[countryCode] || null) : null;
    this.isExperanzaFlowFn = isExperanzaFlowFn;
  }

  transform(text: string): string {
    if (!text || !this.replacements) {
      return text;
    }
    if (this.isExperanzaFlowFn && !this.isExperanzaFlowFn()) {
      return text;
    }
    return this.replacements.reduce((result, rule) => result.replace(rule.from, rule.to), text);
  }
}